import "./WIMCODigital.module.css";
import Header from "@/reusable_sections/Header";
import TradingPlatformOverview from "./sections/TradingPlatformOverview";
import RiskManagementGovernance from "./sections/RiskManagementGovernance";
import Footer from "@/reusable_sections/Footer";
export default function WIMCODigitalPage() {
  return <div>
      <Header />
      <TradingPlatformOverview />
      <RiskManagementGovernance />
      <Footer />
    </div>;
}